<template>
    <div class="image-camera-page">
        <!-- accept="image/*" -->
        <Uploader
            ref="uploader"
            :deletable="false"
            :name="echoField"
            preview-size="100%"
            max-count="1"
            capture="camera"
            :preview-full-image="false"
            :before-read="beforeRead"
            :after-read="afterRead"
        >
            <template v-if="showInner" #default>
                <slot></slot>
            </template>
        </Uploader>
    </div>
</template>

<script>
import Compressor from "compressorjs";
import { IMAGE_LIMIT } from "../../utils/config";
import { lrzUploadImage } from "../../services/upload";
import { Uploader } from "vant";

export default {
    components: {
        Uploader,
    },
    props: {
        echoField: {
            type: String,
            default: "",
        },
        showInner: {
            type: Boolean,
            default: false,
        },
    },
    watch: {},
    data() {
        return {};
    },
    methods: {
        toChooseFile(){
            this.$refs.uploader.chooseFile();
        },
        // 图片修正
        beforeRead(file, detail, i = 1) {
            // console.log("beforeRead", file);
            this.$emit("beforeRead", this.echoField);
            return new Promise((resolve) => {
                // compressorjs 默认开启 checkOrientation 选项
                let quality = 1;
                let len = IMAGE_LIMIT * (1024 * 1024);
                if (file.size > len) {
                    quality = 0.5 ** i;
                }
                // 会将图片修正为正确方向
                new Compressor(file, {
                    checkOrientation: true,
                    quality: quality,
                    success: async (result) => {
                        let nowFile = new File([result], result.name, {
                            type: file.type,
                        });
                        if (i >= 2) {
                            // console.log("2次压缩结束");
                            resolve(result);
                        } else if (result.size > len) {
                            resolve(
                                this.beforeRead(nowFile, detail, Number(i) + 1)
                            );
                        } else {
                            // console.log("成功压缩");
                            resolve(result);
                        }
                    },
                    error(err) {
                        console.log("beforeRead", err);
                    },
                });
            });
        },
        // 上传拦截
        afterRead(file) {
            let vm = this;
            console.log("afterRead111", file);
            lrzUploadImage(file.file,this.echoField, (results, url) => {
                console.log("手持afterRead",results, vm.echoField, url);
                // this.formData[detail.name] = url;
                // console.log("afterRead results结果", results, url);
                vm.$emit("afterRead", results, vm.echoField, url);
            });
            return false;
        },
    },
};
</script>

<style lang="less" scoped>
.image-camera-page {
    .van-uploader {
        width: 100%;
        /deep/ .van-uploader__input-wrapper {
            width: 100%;
        }
    }
}
</style>
